export default __webpack_public_path__ + "static/media/dm_gorgon.9241f9e7.gif";